import request from "./request";

// 录入记录分页查询
export const getRecordPageList = (data) =>
  request("/popuManual/recordPageList", data, "POST_JSON");
// 录入记录明细查询
export const getDetailList = (data) =>
  request("/popuManual/detailList", data, "POST_JSON");
// 数据入库 、删除
export const changeStatus = (data) =>
  request("/popuManual/changeStatus", data, "POST_JSON");
// 保存记录
export const saveRecord = (data) =>
  request("/popuManual/saveRecord", data, "POST_JSON");
// 批量数据上传
export const uploadRecords = (data) =>
  request("/popuManual/uploadRecords", data, "POST_JSON");
// 删除录入数据
export const deleteRecord = (data) =>
  request("/popuManual/deleteRecord", data, "GET");
